import '@grandvisionhq/utils';
import { getUnlocalizedSpecificationItem } from '../utils/get-unlocalized-specification-item.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';
import { mapServerToSpecificationsBase } from './map-server-to-specifications-base.js';
import { getSharedFrameSpecificationItems } from './shared/get-shared-frame-specification-items.js';

const mapServerToFrameSpecifications = (serverVariant, brand, prescriptionGlass)=>{
    const { segment , trend , targetGender , targetGenderAllLocales , lensFeatures , frameFeatures  } = serverVariant.variantTypeDetails;
    const genderUnlocalized = getUnlocalizedSpecificationItem(targetGenderAllLocales);
    return [
        ...mapServerToSpecificationsBase(serverVariant, brand),
        ...getSpecificationItems({
            targetGender,
            genderUnlocalized
        }),
        ...getSharedFrameSpecificationItems({
            segment,
            trend,
            lensFeatures,
            frameFeatures,
            prescriptionGlass
        }), 
    ];
};

export { mapServerToFrameSpecifications };
//# sourceMappingURL=map-server-to-frame-specifications.js.map
